<template>
  <div class="my-list">
    <my-spin v-show="loading"></my-spin>

    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
    >
      <my-list-item v-for="item in dataSource" :key="item.id" :data="item" :btnConfig="btnConfig"></my-list-item>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-list',

  props: {
    dataSource: Array,
    loading: Boolean,
    search: Object,
    btnConfig: {
      type: Array,
      default: function() {
        return []
      }
    },
    flag: Boolean
  },

  data() {
    return {
      current: 0,
      list: this.dataSource
    }
  },

  methods: {
    loadMore() {
     try {
        if (this.flag) {
            this.search.current++
            this.search.isQuery = false
            this.fetchData(this.search)
        }
     } catch (error) {
        console.log(error)
     }
      
    },

    fetchData() {
      this.$parent.fetchData(this.search)
    }
  }
}
</script>
